export const SECOND_BY_MILLISECONDS = 1_000;
export const MINUTE_TIME = SECOND_BY_MILLISECONDS * 60;
export const HOUR_TIME = MINUTE_TIME * 60;
export const DAY_TIME = HOUR_TIME * 24;
